// src/components/charts/WarningsHistogram.jsx
//
// Histogram of warnings_count per run. null → 0. Bins are 0, 1, 2, 3, 4, 5+.
//
import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Bin warnings_count: 0, 1, 2, 3, 4, "5+". Null → 0.
 * Exported for unit testing.
 */
export function warningBuckets(runs) {
  const bins = [
    { bucket: '0', count: 0 },
    { bucket: '1', count: 0 },
    { bucket: '2', count: 0 },
    { bucket: '3', count: 0 },
    { bucket: '4', count: 0 },
    { bucket: '5+', count: 0 },
  ];
  if (!Array.isArray(runs)) return bins;
  for (const r of runs) {
    const w = r?.warnings_count == null ? 0 : r.warnings_count;
    if (w >= 5) bins[5].count += 1;
    else if (w >= 0 && w <= 4) bins[w].count += 1;
  }
  return bins;
}

export default function WarningsHistogram({ runs }) {
  const rows = warningBuckets(runs);
  if (rows.every(r => r.count === 0)) return null;
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={rows} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="bucket" tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <Tooltip contentStyle={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif" }} />
        <Bar dataKey="count" fill="#F59E0B" />
      </BarChart>
    </ResponsiveContainer>
  );
}
